import { Textarea, useMantineTheme } from "@mantine/core";

// Combine TextareaProps with any custom props if needed
type TextQuestionInputProps = {
  onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  questionSlug: string;
  value: string;
  rows?: number;
};

const placeholderMap = {
  "app:custom.questions.something_to_say":
    "대단할 필요 없어요, 그냥 나다운 한 줄! 함께할 그룹에게만 힌트로 공개돼요! 😆 (언제든 변경 가능)",
  "questions.nationality": "입력",
  "questions.birthday": "mm/dd/yyyy",
  "questions.name": "이름을 입력하세요",
  "questions.phone_number": "전화번호를 입력하세요",
  "questions.nickname": "e.g. 영어 이름",
};

export function TextQuestionInput({
  value,
  onChange,
  questionSlug,
  rows = 4,
}: TextQuestionInputProps) {
  const theme = useMantineTheme();

  const isLargeTextQuestion = questionSlug === "something_to_say";

  return (
    <Textarea
      size={"lg"}
      autosize
      minRows={isLargeTextQuestion ? rows : 1}
      placeholder={placeholderMap[questionSlug as keyof typeof placeholderMap]}
      value={value}
      onChange={onChange}
      styles={{
        input: {
          backgroundColor: theme.black,
          color: theme.white,
        },
      }}
    />
  );
}
